import React, { Suspense, lazy } from 'react';
import { createHashRouter, RouterProvider } from 'react-router-dom';

import Loading from '@/components/loading';

// 通过 React.lazy 实现路由级按需加载
const DefaultLayout = lazy(() => import('../../layouts/default-layout'));
const ContentWithHeader = lazy(() => import('../../layouts/default-layout/ContentWithHeader'));
const ContentWithoutHeader = lazy(
  () => import('../../layouts/default-layout/ContentWithoutHeader'),
);
const DemandPage = lazy(() => import('../../pages/demand-list'));
const ProductList = lazy(() => import('../../pages/product-list'));
const Page404 = lazy(() => import('@/pages/page404'));
const Login = lazy(() => import('@/pages/login'));

const AppRouterProvider = () => {
  const router = createHashRouter([
    {
      path: '/',
      element: <DefaultLayout />,
      errorElement: <Page404 />,
      children: [
        {
          path: '/login',
          element: <Login />,
        },
        {
          path: '/',
          element: <ContentWithHeader />,
          errorElement: <Page404 />,
          children: [
            {
              index: true,
              element: <ProductList />,
            },

            {
              path: '/product',
              element: <ProductList />,
            },
            {
              path: '/product/list',
              element: <ProductList />,
            },
          ],
        },
        {
          path: '/',
          element: <ContentWithoutHeader />,
          errorElement: <Page404 />,
          children: [
            {
              path: '/demandlist',
              element: <DemandPage />,
            },
          ],
        },
      ],
    },
  ]);
  return (
    <Suspense fallback={<Loading />}>
      <RouterProvider router={router} fallbackElement={<Page404 />} />
    </Suspense>
  );
};

export default AppRouterProvider;
